import React from 'react';

const ProExclusiveLogo = () => {
  return (
    <div className="flex items-center gap-12">
      <div className="bg-grayscale-50 h-px sm:h-3 w-full" />
      <p className="flex-shrink-0 m-0">
        <span className="font-serif font-medium text-[15px] text-pro-red">Pro</span>{' '}
        <span className="font-sans text-overline text-grayscale-80 uppercase">Exclusive</span>
      </p>
      <div className="bg-grayscale-50 h-px sm:h-3 w-full" />
    </div>
  );
};

export default ProExclusiveLogo;
